import { LoggedApiConnector } from 'Connectors/LoggedApiConnector';
import ConfigProxy            from 'tools/ConfigProxy';
import SalesApiModel          from './SalesApiModel';

export const salesLoggedConnector = new LoggedApiConnector({
	baseURL: ConfigProxy.getServiceConfig('sales', 'api_endpoint'),
});

export default class SalesPrivateApiModel extends SalesApiModel {
	public static get connector() {
		return salesLoggedConnector;
	}
}
